<template>
  <div class="game-container" id="page-game">
    <img class="game-title" src="../../assets/images/game.png" alt="" />
    <img class="left-people" src="../../assets/images/people.png" alt="" />
    <div class="game-content">
      <div class="swiper-container game-swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="../../assets/images/banner06.jpg" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="../../assets/images/banner07.jpg" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="../../assets/images/banner08.jpg" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="../../assets/images/banner09.jpg" alt="" />
          </div>
          <div class="swiper-slide">
            <img src="../../assets/images/banner10.jpg" alt="" />
          </div>
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination game-swiper-pagination"></div>
      <!-- 如果需要导航按钮 -->
      <div class="button-prev"></div>
      <div class="button-next"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      new this.$Swiper(".game-swiper-container", {
        loop: true,
        // 如果需要分页器
        pagination: {
          el: ".game-swiper-pagination",
          clickable: true,
        },
        effect: "coverflow",
        coverflowEffect: {
          rotate: 0,
          stretch: "76.2%",
          depth: 200,
          modifier: 1,
          slideShadows: false,
        },
        centeredSlides: true,
        slidesPerView: "auto",
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".button-next",
          prevEl: ".button-prev",
        },
      });
    });
  },
};
</script>
<style scoped lang="scss" src="./scss/game.scss">
</style>